import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { Report } from "../../models/Reports";

interface ReportDetailsProps {
	// report
	report: Report;
}

const useStyles = makeStyles((theme) => ({
	title: {
		marginBottom: theme.spacing(4),
	},
	details: {
		fontSize: theme.typography.body1.fontSize,
		marginTop: theme.spacing(2),
		display: "block",
	},
	iFrame: {
		marginTop: theme.spacing(2),
		maxWidth: 1024,
	},
}));

/**
 * Page to display Report details.
 * @param props
 */
export const ReportDetails = (props: ReportDetailsProps) => {
	const classes = useStyles();
	return (
		<div>
			<Typography className={classes.title} variant="h4">
				{props.report.name}
			</Typography>
			<div className={classes.iFrame}>
				<iframe width={"100%"} height={600} src={props.report.url}></iframe>
			</div>
			<span className={classes.details}>
				<Typography className={classes.details}>{props.report.description}</Typography>
			</span>
		</div>
	);
};
